import React, {useContext} from 'react'
import user_image from "../../assets/avatar.jpg"
import './Topbar.scss'
import AuthContext from '../../context/AuthContext'
import { IoMdMenu } from "react-icons/io";
import { useGlobalContext } from '../../context/stateContext';


const Topbar = ({title}) => {
  // const {user,openSidebar, setOpenSidebar} = useContext(AuthContext)
  const { user, isSidebarOpen,setIsSidebarOpen} = useGlobalContext();
  
  
  
  return (
    <div className='p-3 flex items-center justify-between border-b border-black fixed top-0 right-0 w-full bg-white'>
        <div className="topbar-title">
            <span className='menu-icon'>
              <IoMdMenu onClick={()=>setIsSidebarOpen(!isSidebarOpen)} className='text-3xl cursor-pointer'/>
            </span>
            
        </div>
        <div className="flex items-center gap-2 ">
            {/* <GrNotification /> */}
            <div className='flex flex-col text-[13px] pr-3 leading-tight text-right'>
              <p>{user?.username}</p>
              <p style={{color:"gray",fontSize:"14px"}}>{user?.role}</p>
            </div>
            <div>
                <img src={user_image} alt='user' className='h-[40px] w-[40px] rounded-full object-cover'/>
            </div>
        </div>
    </div>
  )
}

export default Topbar